export const SIGN_IN_USER = "sign_in_user";
export const SIGN_IN_USER_SUCCESS = "sign_in_user_success";
export const SIGN_IN_USER_FAILED = "sign_in_user_failed";
export const SIGN_OUT_USER = "sign_out_user";

export const GET_SELF = "get_self";
export const GET_SELF_SUCCESS = "get_self_success";
export const GET_SELF_FAILED = "get_self_failed";

export const VALIDATE_USER = "validate_user";
export const VALIDATE_USER_SUCCESS = "validate_user_success";
export const VALIDATE_USER_FAILED = "validate_user_failed";

export const SHOW_ALERT = "show_alert";
export const HIDE_ALERT = "hide_alert";

export const SHOW_CREATE_CORPARATION_MODAL = "show_create_corparation_modal";
export const HIDE_CREATE_CORPARATION_MODAL = "hide_create_corparation_modal";

export const SHOW_SNACKBAR = "show_snackbar";
export const HIDE_SNACKBAR = "hide_snackbar";

// Corporation userActions
export const CREATE_CORPORATION = "create_corporation";
export const CREATE_CORPORATION_SUCCESS = "create_corporation_success";
export const CREATE_CORPORATION_FAILED = "create_corporation_failed";

// Communities
export const GET_COMMUNITIES = "GET_COMMUNITIES";
export const GET_COMMUNITIES_SUCCESS = "GET_COMMUNITIES_SUCCESS";
export const GET_COMMUNITIES_FAILED = "GET_COMMUNITIES_FAILED";

export const CREATE_COMMUNITY = "CREATE_COMMUNITY";
export const CREATE_COMMUNITY_SUCCESS = "CREATE_COMMUNITY_SUCCESS";
export const CREATE_COMMUNITY_FAILED = "CREATE_COMMUNITY_FAILED";

export const UPDATE_COMMUNITY = "UPDATE_COMMUNITY";
export const UPDATE_COMMUNITY_SUCCESS = "UPDATE_COMMUNITY_SUCCESS";
export const UPDATE_COMMUNITY_FAILED = "UPDATE_COMMUNITY_FAILED";

export const DELETE_COMMUNITY = "DELETE_COMMUNITY";
export const DELETE_COMMUNITY_SUCCESS = "DELETE_COMMUNITY_SUCCESS";
export const DELETE_COMMUNITY_FAILED = "DELETE_COMMUNITY_FAILED";

// Appartments
export const CREATE_APPARTMENT = "CREATE_APPARTMENT";
export const CREATE_APPARTMENT_SUCCESS = "CREATE_APPARTMENT_SUCCESS";
export const CREATE_APPARTMENT_FAILED = "CREATE_APPARTMENT_FAILED";

export const DELETE_APPARTMENT = "DELETE_APPARTMENT";
export const DELETE_APPARTMENT_SUCCESS = "DELETE_APPARTMENT_SUCCESS";
export const DELETE_APPARTMENT_FAILED = "DELETE_APPARTMENT_FAILED";



// WEBPACK FOOTER //
// ./src/components/actions/Types.js